export function reloadForIdentityChange(path: string) {
  window.location.assign(path);
}
